export default __webpack_public_path__ + "static/logo22-e59c4b155b4042953eb7af4ad6c9c35a.png";